import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { ActiveInactiveFor, GlobalLocations, KeyValues3, KeyValueSetWrapper, LocalService, StatusWithId, Wrapper3 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class LocationManagementService {
  private controllerName = service_controllers_methods.location.controller;
  private methods = service_controllers_methods.location.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public getChildLocations(strParentId: string, ctryCode: string): Observable<KeyValueSetWrapper> {
    let body = {
      sel: this.localService.getSelected(),
      strParentId: strParentId,
      strCtryCode: ctryCode
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetChildLocations, body);
  }

  public getLocations(strParentId: string): Observable<KeyValues3[]> {
    let body = {
      sel: this.localService.getSelected(),
      strParentId: strParentId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLocations, body);
  }

  public activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor): any {
    let body = {
      sel: this.localService.getSelected(),
      strId: strId,
      iActionFor: parseInt(actionFor.toString())
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  public saveLocation(wrapper: Wrapper3): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      wrapper: wrapper
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveLocation, body);
  }

  public getLocation(id: string): Observable<Wrapper3> {
    let body = {
      sel: this.localService.getSelected(),
      strId: id
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLocation, body);
  }

  public getGlobalLocations(): Observable<GlobalLocations> {
    let body = {
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetGlobalLocations, body);
  }

  public getLocationFile(strId: string, strLanguageId: string) {
    let body = {
      sel: this.localService.getSelected(),
      strId: strId,
      strLanId: strLanguageId
    };
    return this.httpService.request_general_post_blob_response(this.controllerName + this.methods.GetLocationFile, body, true, true);
  }

  public getLocationsWithRoots(strParentId: string): Observable<KeyValues3[][]> {
    let body = {
      sel: this.localService.getSelected(),
      strParentId: strParentId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLocationsWithRoots, body);
  }
}
